import { colors } from '@dixa/lib-shared-tokens';

import { ApiTokenVersion } from 'apis/auth';

type ApiTokenTypes = 'integrationsApi' | 'dixaApi';

export type SelectToken = {
  type: ApiTokenTypes;
  version: ApiTokenVersion;
  label: string;
  color: string;
};

export const integrationsApiToken: SelectToken = {
  type: 'integrationsApi',
  version: '1',
  label: 'Integrations API (DEPRECATED)',
  color: colors.green[400],
};

export const dixaApiToken: SelectToken = {
  type: 'dixaApi',
  version: '2',
  label: 'Dixa API',
  color: colors.purple[400],
};

export const apiTokenTypes = [integrationsApiToken, dixaApiToken];

type ApiTokenTypesByVersion = Record<ApiTokenVersion, SelectToken>;

export const apiTokenTypesByVersion: ApiTokenTypesByVersion =
  apiTokenTypes.reduce(
    (obj, current) => ({
      ...obj,
      [current.version]: current,
    }),
    {} as ApiTokenTypesByVersion,
  );
